/* AtlassianAppTileCompact.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
import { BodyNormal, H5 } from '@atlassian/mpac-primitives';
import { TEST_IDS } from '../../primitives/testIds';
import { AppLogoWrapperCompact, AppNameWrapper, AppTileContainer, AppTileHeaderCompact, AppTileLinkCompact } from './AppTile.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _16 = "._p12f1osq{max-width:100%}";
const _15 = "._1e0c1ule{display:block}";
const _14 = "._vwz4pxbi{line-height:var(--ds-space-200,1pc)}";
const _13 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _12 = "._1wyboqnp{font-size:.75rem}";
const _11 = "._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}";
const _10 = "@media (min-width:64rem){._3p1c140y{font-size:var(--ds-font-heading-xsmall,normal 600 14px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}._py5ov47k{line-height:var(--ds-space-250,20px)}}";
const _9 = "._vwz4v47k{line-height:var(--ds-space-250,20px)}";
const _8 = "._1wyb140y{font-size:var(--ds-font-heading-xsmall,normal 600 14px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _7 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _6 = "._o5721q9c{white-space:nowrap}";
const _5 = "._1bto1l2s{text-overflow:ellipsis}";
const _4 = "._ect41gqc{font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _3 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _2 = "._18m915vq{overflow-y:hidden}";
const _ = "._1reo15vq{overflow-x:hidden}";
const HeadingStyle = null;
const PartnerDetailsWrapperStyle = null;
export function AtlassianAppTileCompact(_ref) {
  let {
    productName,
    description,
    onClick: _onClick,
    brandIcon
  } = _ref;
  return /*#__PURE__*/_jsx(AppTileContainer, {
    children: /*#__PURE__*/_jsx(AppTileLinkCompact, {
      to: "#",
      onClick: e => {
        e.preventDefault();
        _onClick();
      },
      "data-testid": TEST_IDS.ATLASSIAN_APP_TILE_COMPACT,
      children: /*#__PURE__*/_jsxs(AppTileHeaderCompact, {
        children: [/*#__PURE__*/_jsx(AppLogoWrapperCompact, {
          children: brandIcon
        }), /*#__PURE__*/_jsxs(AppNameWrapper, {
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10]
            }), /*#__PURE__*/_jsx(H5, {
              className: ax(["_1reo15vq _18m915vq _18s8ze3t _ect41gqc _1bto1l2s _o5721q9c _k48p1wq8 _1wyb140y _vwz4v47k _3p1c140y _py5ov47k"]),
              children: productName
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_3, _, _2, _11, _12, _13, _14, _6, _5, _15, _16]
            }), /*#__PURE__*/_jsx(BodyNormal, {
              className: ax(["_18s8ze3t _1reo15vq _18m915vq _k48pi7a9 _1wyboqnp _syaz1gjq _vwz4pxbi _o5721q9c _1bto1l2s _1e0c1ule _p12f1osq"]),
              children: description
            })]
          })]
        })]
      })
    })
  });
}